export function getEnvironment() {
  if (
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('127.0.0.1')
  ) {
    return 'local'
  }
  if (window.location.hostname.includes('develop')) {
    return 'develop'
  }
  return 'prod'
}
